import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import ScrollToTop from './components/layout/ScrollToTop';
import PageTransition from './components/animations/PageTransition';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import DealsPage from './pages/DealsPage';
import TeamPage from './pages/TeamPage';
import JobsPage from './pages/JobsPage';
import JobDetailPage from './pages/JobDetailPage';
import BlogArticlePage from './pages/BlogArticlePage';
import CanvaProPage from './pages/services/CanvaProPage';
import HebergementPage from './pages/services/HebergementPage';
import RessourcesPage from './pages/services/RessourcesPage';
import VPSPage from './pages/services/VPSPage';
import LogicielsPage from './pages/services/LogicielsPage';
import MailPage from './pages/services/MailPage';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="relative min-h-screen bg-white">
        <Navbar />
        <AnimatePresence mode="wait">
          <Routes>
            <Route
              path="/"
              element={
                <PageTransition>
                  <HomePage />
                </PageTransition>
              }
            />
            <Route
              path="/about"
              element={
                <PageTransition>
                  <AboutPage />
                </PageTransition>
              }
            />
            <Route
              path="/deals"
              element={
                <PageTransition>
                  <DealsPage />
                </PageTransition>
              }
            />
            <Route
              path="/team"
              element={
                <PageTransition>
                  <TeamPage />
                </PageTransition>
              }
            />
            <Route
              path="/jobs"
              element={
                <PageTransition>
                  <JobsPage />
                </PageTransition>
              }
            />
            <Route
              path="/jobs/:id"
              element={
                <PageTransition>
                  <JobDetailPage />
                </PageTransition>
              }
            />
            <Route
              path="/blog/:id"
              element={
                <PageTransition>
                  <BlogArticlePage />
                </PageTransition>
              }
            />
            <Route
              path="/services/canva-pro"
              element={
                <PageTransition>
                  <CanvaProPage />
                </PageTransition>
              }
            />
            <Route
              path="/services/hebergement"
              element={
                <PageTransition>
                  <HebergementPage />
                </PageTransition>
              }
            />
            <Route
              path="/services/ressources"
              element={
                <PageTransition>
                  <RessourcesPage />
                </PageTransition>
              }
            />
            <Route
              path="/services/vps"
              element={
                <PageTransition>
                  <VPSPage />
                </PageTransition>
              }
            />
            <Route
              path="/services/logiciels"
              element={
                <PageTransition>
                  <LogicielsPage />
                </PageTransition>
              }
            />
            <Route
              path="/services/mail"
              element={
                <PageTransition>
                  <MailPage />
                </PageTransition>
              }
            />
            {/* Gestion des routes inconnues */}
            <Route
              path="*"
              element={
                // Si le chemin est un fichier statique, ne pas rediriger
                window.location.pathname.includes('.') ? null : <Navigate to="/" replace />
              }
            />
          </Routes>
        </AnimatePresence>
        <Footer />
      </div>
    </Router>
  );
}

export default App;